
import Vue, { PropType } from 'vue';
import { CvCvSection } from '@/../gen';

export default Vue.extend({
  props: {
    cvCvSection: {
      type: Object as PropType<CvCvSection>,
      required: true,
    },
    sortUpHandler: {
      type: Function,
      default: null,
    },
    sortDownHandler: {
      type: Function,
      default: null,
    },
  },
});
